export class WalletSearch
{
    searchstoreid: string;
    searchmerchantreference: string;
    searchentrytype: string;
    searchfromdate: string;
    searchtodate: string;
    searchsmartcard: string;
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/walletsearchmodel.ts